import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import GrayledDropdown from '../../components/GrayledDropdown';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import dragDrop from '../../assets/images/model/drag_drop.svg';
import HtmlAsText from '../../components/createmode/HtmlAsText';
import uparrow from '../../assets/images/model/uparrow.svg';
import arrow_down from '../../assets/images/angle_up_down.svg';
import trash from '../../assets/images/model/trash-2.svg';
import close from '../../assets/images/model/close.png';
import DetailsTab from '../../components/createmode/DetailsTab';
import angleDown from '../../assets/images/model/angle-down.png';
import DraggableBlocks from '../../components/createmode/DraggableBlocks';
import AddImage from '../../components/addMedia/AddImage';
import AddVideo from '../../components/addMedia/AddVideo';
import AddAudio from '../../components/addMedia/AddAudio';
import ArrowUp from '../../assets/images/model/errow-up.svg';
export default function SideBar({ activityFilter, handleActivityTitleClick = () => {}, highlightChapter, setCurrentTab, handleDragEndAccordion, handleChapterSelect, activeChapter, toggleCollapse, activeIds, setScrollToId, dropdownRef, handleClick, isClicked, isSelectedOption, handleAddChapter, setIsClicked, setVisibleSection, setIsSelectedOption, handleAddSectionClick, setBook, addTextBook, setAddTextBook, handleDragStart, currentTab, addTextBookButton, handleChapterDelete, setDraggedType }) {
  const { book } = useSelector((state) => state.entities.book);
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const blocks = ['chapter', 'section', 'small_header', 'paragraph'];

  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };

  // Filter Chapter Activity in RHSB

  return (
    <div className='left_side_bar_create'>
      <div className='top_content '>
        <div
          style={{
            position: 'sticky',
            background: '#fafaf9',
            zIndex: 1,
          }}
        >
          <div className='logo_brand_create padding_left padding_title_logo'>
            <GrayledDropdown mode='create' />
          </div>
          <ul className='nav nav-tabs custom_tabs_create ' id='custom_tabs_create' role='tablist'>
            <li className='nav-item padding_title_logo' role='presentation'>
              <button
                className='nav-link active'
                id='Contents-tab'
                data-bs-toggle='tab'
                data-bs-target='#Contents'
                type='button'
                role='tab'
                aria-controls='Contents'
                aria-selected='true'
                onClick={() => {
                  setCurrentTab('content');
                }}
              >
                Contents
              </button>
            </li>
            <li className='nav-item padding_title_logo' role='presentation'>
              <button
                className='nav-link'
                id='Details-tab'
                data-bs-toggle='tab'
                data-bs-target='#Details'
                type='button'
                role='tab'
                aria-controls='Details'
                aria-selected='false'
                onClick={() => {
                  setCurrentTab('detail');
                }}
              >
                Details
              </button>
            </li>
          </ul>
        </div>
        <div
          className='tab-content'
          id='custom_tabsContent'
          style={{
            height: 'calc(100vh - 170px)',
            overflowY: 'scroll',
          }}
        >
          <div className='tab-pane fade show active' id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
            <div className='Contents_Wrap_create accordion_Wrap'>
              <h1 className='f-16 mini_title padding_left padding_title_logo'>{book.book.title}</h1>

              <div className='accordion accordion-flush' id='accordionFlushExample' style={{ marginTop: '0px' }}>
                <DragDropContext onDragEnd={handleDragEndAccordion}>
                  <Droppable droppableId='accordionItems'>
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {book.chapters.map((item, index) => (
                          <Draggable key={item._id} draggableId={item._id} index={index}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={(e) => {
                                  handleChapterSelect(item._id);
                                }}
                              >
                                <div className='accordion-item  ' style={{ marginBottom: '5px' }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <div className={`img-flex_row `}>
                                      <div
                                        style={{
                                          width: '8px',
                                          marginRight: '1px',
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div
                                          className={`drag_drop ${snapshot.isDragging ? 'draggingShow' : ''}`}
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'top',
                                            height: '100%',
                                          }}
                                        >
                                          <img
                                            src={dragDrop}
                                            alt=''
                                            style={{
                                              cursor: 'grab',
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className={`inner_Wrap_create ${snapshot.isDragging ? 'drag_droped_color' : ''} `}
                                        onClick={(e) => {
                                          // toggleCollapse(item._id);
                                          expendSidebar(e, item._id);
                                          setScrollToId(item?._id);
                                        }}
                                      >
                                        <div className={`accordion-header padding_left d-flex align-items-center gap-1 ${sideBar.includes(item?._id) ? 'bg_grey' : ''}`} style={{ paddingRight: '4px' }} aria-expanded={sideBar.includes(item?.title) ? true : false}>
                                          <p
                                            style={{
                                              cursor: 'pointer',
                                              alignItems: 'start',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              // width: "350px"
                                            }}
                                            className={`accordion-button mb-0 collapsed  ${snapshot.isDragging ? 'drag_droped_ttitle' : ''}  ${sideBar.includes(item?._id) ? 'bg_grey' : ''} `}
                                          >
                                            <HtmlAsText htmlContent={item.title} />
                                          </p>

                                          {item?.sections?.length > 0 && (
                                            <img
                                              width={12}
                                              height={12}
                                              src={arrow_down}
                                              alt='arrow'
                                              style={{
                                                cursor: 'pointer',
                                                transform: sideBar.includes(`${item?._id}`) ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                              }}
                                              // style={{
                                              //   cursor: 'pointer',
                                              //   filter: snapshot.isDragging ? 'brightness(0) saturate(100%) invert(13%) sepia(91%) saturate(5609%) hue-rotate(276deg) brightness(70%) contrast(118%)' : 'none',
                                              // }}
                                            />
                                          )}
                                        </div>

                                        <a
                                          href='#'
                                          className={`minus_icon  ${snapshot.isDragging ? 'draggingShow' : ''}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleChapterDelete('chapter', item._id);
                                          }}
                                        >
                                          <img
                                            src={trash}
                                            alt='close'
                                            style={{
                                              filter: snapshot.isDragging ? 'brightness(0) saturate(100%) invert(13%) sepia(91%) saturate(5609%) hue-rotate(276deg) brightness(70%) contrast(118%)' : 'none',
                                            }}
                                          />
                                        </a>
                                      </div>
                                    </div>

                                    <div id={`flush-collapse_${item._id}`} style={{ padding: '2px , 0px' }} className={sideBar.includes(item?._id) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent='#accordionFlushExample'>
                                      <div className='accordion-body faq_inner mr_l' style={{ gap: '8px', display: 'flex', flexDirection: 'column', paddingLeft: '16px' }}>
                                        <>
                                          {book.activities
                                            .filter((e) => e.chapter === item._id && !e.section)
                                            .map((e, index) => (
                                              <div key={index} className='accordion-item'>
                                                <div
                                                  className='inner_Wrap'
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    setScrollToId(item._id);
                                                    handleActivityTitleClick(e?._id);
                                                  }}
                                                >
                                                  <h2
                                                    className='accordion-header'
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      width: 'fit-content',
                                                    }}
                                                  >
                                                    <button style={{ paddingBottom: '0px' }} className='accordion-button accordion_section collapsed purple' type='button' data-bs-toggle='collapse' data-bs-target={`#flush-collapse_activity_${e._id}`} aria-expanded={sideBarSection.includes(`${item?._id}`)} aria-controls={`flush-collapse_activity_${e._id}`}>
                                                      <HtmlAsText htmlContent={e.title} />
                                                    </button>
                                                  </h2>
                                                </div>
                                              </div>
                                            ))}
                                          {item.sections.map((section) =>
                                            section ? ( // Check if section is defined
                                              <div key={section._id} className='accordion-item'>
                                                <div
                                                  className='inner_Wrap'
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setScrollToId(`${item._id}.${section._id}`);
                                                    toggleSidebarSection(e, `${item?._id}-${section._id}`);
                                                  }}
                                                >
                                                  <h2
                                                    className='accordion-header'
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      width: 'fit-content',
                                                      // paddingBottom: '4px',
                                                      // paddingTop: '4px',
                                                    }}
                                                  >
                                                    <button className={`accordion-button accordion_section collapsed `} data-id={`${item._id}.${section._id}`} type='button' data-bs-toggle='collapse' data-bs-target={`#flush-collapse_section_${section._id}`} aria-expanded={sideBarSection.includes(`${item?._id}-${section._id}`)} aria-controls={`flush-collapse_section_${section._id}`}>
                                                      <HtmlAsText htmlContent={section?.title} />
                                                    </button>

                                                    {book.activities.some((e) => e.section === section._id && !e.paragraph) && (
                                                      <img
                                                        src={arrow_down}
                                                        alt='arrow'
                                                        style={{
                                                          cursor: 'pointer',
                                                          transform: sideBarSection.includes(`${item?._id}-${section._id}`) ? 'rotate(180deg)' : 'rotate(0deg)',
                                                          transition: 'transform 0.3s ease',
                                                        }}
                                                      />
                                                    )}
                                                  </h2>
                                                  <div id={`flush-collapse_section_${section._id}`} className={`accordion-collapse collapse ${sideBarSection.includes(`${item?._id}-${section._id}`) ? 'show' : ''}`}>
                                                    <div className='accordion-body' style={{ paddingLeft: '16px' }}>
                                                      {book.activities
                                                        .filter((e) => e.section === section._id && !e.paragraph)
                                                        .map((e, index) => (
                                                          <div key={index} className='accordion-item'>
                                                            <div
                                                              className='inner_Wrap'
                                                              onClick={(event) => {
                                                                event.stopPropagation();
                                                                setScrollToId(`${item._id}.${section._id}`);
                                                                handleActivityTitleClick(e?._id);
                                                              }}
                                                            >
                                                              <h2
                                                                className='accordion-header'
                                                                style={{
                                                                  display: 'flex',
                                                                  alignItems: 'baseline',
                                                                  width: 'fit-content',
                                                                  paddingBottom: '2px',
                                                                  paddingTop: '2px',
                                                                }}
                                                              >
                                                                <button style={{ marginBottom: '0px' }} className='accordion-button accordion_section collapsed purple' type='button' data-bs-toggle='collapse' data-bs-target={`#flush-collapse_activity_${e._id}`} aria-expanded={sideBarSection.includes(`${item?._id}-${section._id}`)} aria-controls={`flush-collapse_activity_${e._id}`}>
                                                                  <HtmlAsText htmlContent={e.title} />
                                                                </button>
                                                              </h2>
                                                            </div>
                                                          </div>
                                                        ))}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null
                                          )}
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
              <div className='custom_droup_down padding_title_logo' ref={dropdownRef}>
                <button type='button' className='add_more_btn_create' onClick={handleClick}>
                  <img
                    src={close}
                    alt='close'
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isSelectedOption === 'chapter') {
                        handleAddChapter();
                      } else if (isSelectedOption === 'section') {
                        handleAddSectionClick();
                      }
                    }}
                  />
                  Add <u className={isClicked ? 'select-chapter-section' : ''}>{isSelectedOption}</u> option
                </button>
                {isClicked && (
                  <ul className=''>
                    <li
                      onClick={() => {
                        handleAddChapter();
                        setIsClicked(false);
                        setVisibleSection(true);
                        setIsSelectedOption('chapter');
                      }}
                    >
                      chapter
                    </li>
                    <li
                      onClick={() => {
                        handleAddSectionClick();
                        setIsClicked(false);
                        setIsSelectedOption('section');
                      }}
                    >
                      section
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className='tab-pane fade' id='Details' role='tabpanel' aria-labelledby='Details-tab'>
            <DetailsTab book={book} setBook={setBook} />
          </div>
        </div>
      </div>
      <div className={`bottom_button_create`}>
        {addTextBook ? (
          <div
            className={`bottom_tabs_new_create " +
                      ${addTextBook && 'animate-up'} `}
          >
            <a className={`angle_down_btn_create `} onClick={() => setAddTextBook(false)}>
              <img src={angleDown} alt='angle' />
              close
            </a>
            <ul className='nav nav-tabs custom_tabs_create create' id='custom_tabs_bottm' role='tablist'>
              <li className='nav-item' role='presentation'>
                <button className='nav-link active' id='add_a_block-tab' data-bs-toggle='tab' data-bs-target='#add_a_block' type='button' role='tab' aria-controls='Contents' aria-selected='true'>
                  Add a block
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button className='nav-link' id='Add_media-tab' data-bs-toggle='tab' data-bs-target='#Add_media' type='button' role='tab' aria-controls='Add_media' aria-selected='false'>
                  Add media
                </button>
              </li>
            </ul>
            <div className='tab-content ' id='custom_tabsContent_bottom'>
              <div className='tab-pane show active padding_top' id='add_a_block' role='tabpanel' aria-labelledby='add_a_block-tab'>
                <div className='Contents_Wrap_create accordion_Wrap'>
                  <div className='drag_and_drop'>
                    {blocks.map((block, index) => (
                      <DraggableBlocks onDragStart={(e) => handleDragStart(e, block)} setDraggedType={setDraggedType} index={index} type={block} key={index} toggleBlock={() => setAddTextBook(false)} />
                    ))}
                  </div>
                </div>
              </div>
              <div className='tab-pane fade padding_top' id='Add_media' role='tabpanel' aria-labelledby='Add_media-tab'>
                <div className='details_wrap'>
                  <div className='drag_and_drop'>
                    <AddImage setDraggedType={setDraggedType} draggable onDragStart={(e) => handleDragStart(e, 'image')} />
                    <AddVideo setDraggedType={setDraggedType} draggable onDragStart={(e) => handleDragStart(e, 'video')} />
                    <AddAudio setDraggedType={setDraggedType} draggable onDragStart={(e) => handleDragStart(e, 'audio')} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Fragment>
            {currentTab !== 'detail' && (
              <button type='button' className='open_button_create' onClick={(e) => addTextBookButton()}>
                Add a textbook block <img src={ArrowUp} alt='arrowUp' />
              </button>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}
